"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SportQuestionsResponseDtoTierEnum = void 0;
exports.instanceOfSportQuestionsResponseDto = instanceOfSportQuestionsResponseDto;
exports.SportQuestionsResponseDtoFromJSON = SportQuestionsResponseDtoFromJSON;
exports.SportQuestionsResponseDtoFromJSONTyped = SportQuestionsResponseDtoFromJSONTyped;
exports.SportQuestionsResponseDtoToJSON = SportQuestionsResponseDtoToJSON;
exports.SportQuestionsResponseDtoToJSONTyped = SportQuestionsResponseDtoToJSONTyped;
var OnboardingQuestionStepDto_1 = require("./OnboardingQuestionStepDto");
var DigestCopyDto_1 = require("./DigestCopyDto");
/**
 * @export
 */
exports.SportQuestionsResponseDtoTierEnum = {
    Free: 'free',
    Pro: 'pro',
    Champion: 'champion'
};
/**
 * Check if a given object implements the SportQuestionsResponseDto interface.
 */
function instanceOfSportQuestionsResponseDto(value) {
    if (!('sportCode' in value) || value['sportCode'] === undefined)
        return false;
    if (!('tier' in value) || value['tier'] === undefined)
        return false;
    if (!('steps' in value) || value['steps'] === undefined)
        return false;
    return true;
}
function SportQuestionsResponseDtoFromJSON(json) {
    return SportQuestionsResponseDtoFromJSONTyped(json, false);
}
function SportQuestionsResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sportCode': json['sportCode'],
        'tier': json['tier'],
        'flowPattern': json['flowPattern'] == null ? undefined : json['flowPattern'],
        'intro': json['intro'] == null ? undefined : (0, DigestCopyDto_1.DigestCopyDtoFromJSON)(json['intro']),
        'steps': (json['steps'].map(OnboardingQuestionStepDto_1.OnboardingQuestionStepDtoFromJSON)),
    };
}
function SportQuestionsResponseDtoToJSON(json) {
    return SportQuestionsResponseDtoToJSONTyped(json, false);
}
function SportQuestionsResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'sportCode': value['sportCode'],
        'tier': value['tier'],
        'flowPattern': value['flowPattern'],
        'intro': (0, DigestCopyDto_1.DigestCopyDtoToJSON)(value['intro']),
        'steps': (value['steps'].map(OnboardingQuestionStepDto_1.OnboardingQuestionStepDtoToJSON)),
    };
}
